<template>
  <div class="language-picker">
    <button
      href="#"
      class="language-btn flex"
      @click="toggleVisibility"
    >
      <img :src="getImgUrl($i18n.locale)" alt="flag" width="40">
      <span class="ml-2 selected-language">{{ $i18n.locale.toUpperCase() }}</span>
      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path class="heroicon-ui" d="M15.3 9.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"></path></svg>
    </button>
    <transition name="dropdown-fade">
      <ul v-if="isVisible" ref="dropdown" class="language-list z-30">
        <li>
          <a
            href="#"
            @click.prevent="setLocaleAndLog('en')"
            ref="account"
            class="flex items-center px-3 py-3"
          >
            <img src="@/assets/images/languages/flag_en.png" alt="english flag" class="flag-img">
            <span class="ml-2">English</span>
          </a>
        </li>
        
        <li>
          <a
            href="#"
            @click.prevent="setLocaleAndLog('fr')"
            class="flex items-center px-3 py-3"
          >
            <img src="@/assets/images/languages/flag_fr.png" alt="quebec flag" class="flag-img">
            <span class="ml-2">French</span>
          </a>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions} from 'vuex';
import {UPDATE_LANGUAGE, GET_PROFILE_DATA} from '@/store/action.types'
import { TOASTER_SUCCESS } from '@/common/events.types';

export default {
  props: {
    onLangChange : Function
  },

  data() {
    return {
      isVisible: false
    }
  },

  computed: {
    ...mapGetters([
      'user'
    ])
  },

  methods: {

    ...mapActions({
      updateLanguageAction : UPDATE_LANGUAGE,
      getProfileData: GET_PROFILE_DATA
    }),

    getImgUrl(languageLabel) {
      const images = require.context('./../../assets/images/languages', false, /\.png$/);

      return images(`./flag_${languageLabel}.png`)
    },
    toggleVisibility() {
      this.isVisible = !this.isVisible
    },
    hideDropdown() {
      this.isVisible = false
      this.focusedIndex = 0
    },
  
    setLocaleAndLog(locale) {
      this.$amplitude.logEvent('pwa: change language', {language: locale.toUpperCase()})
      this.$i18n.locale = locale
      this.hideDropdown()
      document.querySelector('html').setAttribute('lang', locale)

      if(this.onLangChange) {
        this.onLangChange(locale.toUpperCase());
      }

      if (this.$router.currentRoute.name == "Profile") {
        // in profile compoennt send request to update language
        this.updateLanguageAction({
          accountId : this.user.accountId,
          language : locale.toUpperCase()
        })
        .then((data) => {
          this.user.language = locale.toUpperCase();
          this.getProfileData(this.user.accountId)
          this.$eventHub.$emit(TOASTER_SUCCESS, { message: this.$t('PROFILE.toastMessages.profileUpdated') })
        })
        .catch((error) => {
        })

      }
    },
  }
}
</script>

<style lang="scss" scoped>
    .language-picker {
      float: right;
      width: 140px;
      height: 30px;
      margin-top: 20px;
      position: relative;
      z-index: 10;

      .selected-language {
        color: #ffffff;
      }
      
      .language-btn {
        background-color: transparent;
        border: none;
        color: $mid-gray;
        &:focus {
          outline: none;
        }
      }

      .language-list {
        padding: 10px 3px;
        list-style-type: none;
        background-color: $shark-gray-3;
        a {
          color: white;
        }
      }
      
      .flag-img {
        width: 40px;
      }
    }

  .dropdown-fade-enter-active, .dropdown-fade-leave-active {
    transition: all .1s ease-in-out;
  }
  .dropdown-fade-enter, .dropdown-fade-leave-to {
    opacity: 0;
    transform: translateY(-12px);
  }
</style>